import React from 'react'
import PropTypes from 'prop-types'

import { ClockIcon, Delivery, Restoran, Edit, Arrow } from './Svg'

class Main extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      isSwitching: false
    }
  }

  // Функция для проверки, открыт ли ресторан в текущее время
  isRestaurantOpen = (worktime) => {
    if (!worktime) return false
    
    try {
      const [openTime, closeTime] = worktime.split('-')
      const [openHours, openMinutes] = openTime.split(':').map(Number)
      const [closeHours, closeMinutes] = closeTime.split(':').map(Number)
      
      const now = new Date()
      const currentHours = now.getHours()
      const currentMinutes = now.getMinutes()
      
      const currentTotalMinutes = currentHours * 60 + currentMinutes
      const openTotalMinutes = openHours * 60 + openMinutes
      const closeTotalMinutes = closeHours * 60 + closeMinutes
      
      return currentTotalMinutes >= openTotalMinutes && currentTotalMinutes <= closeTotalMinutes
    } catch (error) {
      console.error('Error parsing worktime:', error)
      return false
    }
  }

  handleDeliveryTypeChange = (type) => {
    this.setState({ isSwitching: true })
    
    // Задержка для анимации перед фактическим изменением
    setTimeout(() => {
      this.props.changeDeliveryType(type)
      // Сброс состояния после завершения анимации
      setTimeout(() => {
        this.setState({ isSwitching: false })
      }, 300)
    }, 150)
  }

  render() {
    const { user, restaurant, showLocation, changeDeliveryType, showUsloviyaWin } = this.props
    const { isSwitching } = this.state
    const isOpen = restaurant?.worktime ? this.isRestaurantOpen(restaurant.worktime) : false
    const delivery = user?.delivery_type == `delivery`

    return (
      <div className='mt-[8px] bg-white rounded-[25px] p-[10px]'>
        {/* Переключатель доставки/самовывоза */}
        <div className='w-100 h-[40px] bg-[#F6F6F6] flex items-center justify-between rounded-full relative'>
          {/* Фоновая плашка, которая перемещается */}
          <div 
            className={`absolute h-[40px] flex-1 bg-[#5A91FF] text-white rounded-full transition-all duration-300 ease-in-out ${
              delivery ? 'left-0' : 'left-1/2'
            }`}
            style={{ width: '50%' }}
          />
          
          {/* Кнопка Доставка */}
          <div 
            onClick={() => !delivery && this.handleDeliveryTypeChange('delivery')}
            className={`h-[40px] flex-1 flex items-center justify-center gap-[6px] font-[14px] rounded-full relative z-10 cursor-pointer transition-all duration-300 ${
              delivery ? 'text-white' : 'text-dark'
            }`}
          >
            <div className={`transition-transform duration-300 ${delivery ? 'scale-110' : 'scale-100'}`}>
              <Delivery />
            </div>
            <div className={`transition-all duration-300 ${delivery ? 'font-semibold' : ''}`}>
              Доставка
            </div>
          </div>
          
          {/* Кнопка Самовывоз */}
          <div 
            onClick={() => delivery && this.handleDeliveryTypeChange('pickup')}
            className={`h-[40px] flex-1 flex items-center justify-center gap-[6px] font-[14px] rounded-full relative z-10 cursor-pointer transition-all duration-300 ${
              !delivery ? 'text-white' : 'text-dark'
            }`}
          >
            <div className={`transition-transform duration-300 ${!delivery ? 'scale-110' : 'scale-100'}`}>
              <Restoran />
            </div>
            <div className={`transition-all duration-300 ${!delivery ? 'font-semibold' : ''}`}>
              Самовывоз
            </div>
          </div>
        </div>

        {/* Адресная секция с плавным переходом */}
        <div className="relative overflow-hidden">
          {/* Контент для доставки */}
          <div 
            className={`transition-all duration-300 ease-in-out ${
              delivery 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 -translate-y-full absolute top-0 left-0 w-full'
            }`}
            style={{ 
              height: delivery ? 'auto' : '0',
              pointerEvents: delivery ? 'auto' : 'none'
            }}
          >
            <div className='text-[14px] text-[#00000099] mt-[10px]'>Адрес доставки</div>
            <div onClick={() => showLocation()} className='flex items-center justify-between gap-[5px]'>
              <div className='text-[16px] font-semibold text-black'>{user?.location?.address || `Укажите ваш адрес!`}</div>
              <div className="flex-none w-[30px] h-[30px] rounded-full bg-[#F6F6F6] flex items-center justify-center cursor-pointer hover:bg-[#E0E0E0] transition-colors duration-200">
                <Edit />
              </div>
            </div>
            <div className='w-100 h-[30px] mt-[5px] bg-[#F6F6F6] rounded-full flex items-center justify-between text-[14px] text-[#00000099] px-[15px]'>
              <div className='flex items-center gap-[6px]'>
                <ClockIcon />
                <div>Доставим на адрес</div>
              </div>
              <div className='flex items-center gap-[5px]'>
                <div>
                  от <span className='text-black'>{user?.location?.sum_min} ₽</span>
                  {user?.location?.time != `` && <> за <span className='text-black'>{user?.location?.time} мин</span></>}
                </div>
                <div onClick={() => showUsloviyaWin()} className='cursor-pointer ml-1 hover:scale-110 transition-transform duration-200'>
                  <Arrow />
                </div>
              </div>
            </div>
          </div>

          {/* Контент для самовывоза */}
          <div 
            className={`transition-all duration-300 ease-in-out ${
              !delivery 
                ? 'opacity-100 translate-y-0' 
                : 'opacity-0 translate-y-full absolute top-0 left-0 w-full'
            }`}
            style={{ 
              height: !delivery ? 'auto' : '0',
              pointerEvents: !delivery ? 'auto' : 'none'
            }}
          >
            <div className='text-[14px] text-[#00000099] mt-[10px]'>Где заберете заказ?</div>
            <div onClick={() => showLocation()} className='flex items-center justify-between gap-[5px]'>
              <div className='text-[16px] font-semibold text-black'>{restaurant?.adres || `Укажите ваш адрес!`}</div>
              <div className="flex-none w-[30px] h-[30px] rounded-full bg-[#F6F6F6] flex items-center justify-center cursor-pointer hover:bg-[#E0E0E0] transition-colors duration-200">
                <Edit />
              </div>
            </div>
            <div className='flex items-center gap-[6px] mt-[5px] mb-[10px]'>
              {isOpen ? (
                <div className='bg-[#A6DD2F] text-white text-[12px] flex items-center h-[20px] px-[8px] rounded-full transition-all duration-300 hover:scale-105'>
                  открыто
                </div>
              ) : (
                <div className='bg-[#F87605] text-white text-[12px] flex items-center h-[20px] px-[8px] rounded-full transition-all duration-300 hover:scale-105'>
                  закрыто
                </div>
              )}
              <div className='text-[#00000099] text-[14px] transition-opacity duration-300'>
                {restaurant?.worktime}
              </div>
            </div>
          </div>
        </div>
      </div>
    )
  }
}

Main.propTypes = {
  user: PropTypes.object,
  restaurant: PropTypes.object,
  showLocation: PropTypes.func,
  changeDeliveryType: PropTypes.func,
  showUsloviyaWin: PropTypes.func
}

export default Main